import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Share2 } from "lucide-react";

export default function ReferralCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/referrals/me"); setData(data); } catch {}
    })();
  }, []);

  if (!data) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.share_url);
      toast.success("Share link copied");
    } catch { toast.error("Copy failed"); }
  };
  const share = async () => {
    const text = `I'm using MoneyWise AI to find money I can save every month. Sign up with my link and get 1 month of Premium free.`;
    try {
      if (navigator.share) await navigator.share({ text, url: data.share_url });
      else { await navigator.clipboard.writeText(`${text}\n${data.share_url}`); toast.success("Copied to clipboard"); }
    } catch {}
  };

  return (
    <div className="rounded-3xl bg-gradient-to-br from-emerald-500 to-emerald-600 text-white p-5 relative overflow-hidden" data-testid="referral-card">
      <div className="absolute -right-6 -top-6 opacity-20"><Gift size={100} /></div>
      <div className="relative">
        <div className="text-[11px] uppercase tracking-widest text-emerald-100 font-bold">Give a month, get a month</div>
        <div className="mt-1 font-manrope text-xl font-extrabold tracking-tight">Invite friends, both go Premium.</div>
        <p className="mt-1 text-sm text-emerald-100 leading-relaxed">Every friend who signs up gets 1 free month — and you get 1 too.</p>

        <div className="mt-4 rounded-xl bg-white/15 backdrop-blur px-3 py-2 flex items-center gap-2">
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-wider text-emerald-100 font-semibold">Your code</div>
            <div className="font-mono font-bold tracking-wide truncate" data-testid="referral-code">{data.referral_code}</div>
          </div>
          <button data-testid="referral-copy-btn" onClick={copy} className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors" aria-label="Copy"><Copy size={14} /></button>
        </div>

        <div className="mt-3 flex items-center justify-between text-xs text-emerald-50">
          <div><b className="font-manrope text-white text-base" data-testid="referral-count">{data.referrals_count}</b> friends joined</div>
          <div><b className="font-manrope text-white text-base">{data.days_earned}</b> days earned</div>
        </div>

        <button data-testid="referral-share-btn" onClick={share} className="mt-4 w-full bg-white text-emerald-700 rounded-full py-3 font-semibold hover:bg-emerald-50 active:scale-[0.98] transition-transform duration-150 flex items-center justify-center gap-2">
          <Share2 size={16} /> Share your link
        </button>
      </div>
    </div>
  );
}
